import { Breadcrumb } from "../../components";
import Heading from "../../components/Heading";
import MainLayout from "../../layouts/main";
import styled from "styled-components";
import FacilityList from "./FacilityList";
import useBreakpoint from "../../hooks/useBreakpoint";

const StyledWrapper = styled("div")`
  padding-top: 140px;
  min-height: 100vh;
`;

const StyledContentContainer = styled("div")`
  margin: 0 auto;
  max-width: 1440px;
  width: 100%;
  ${({ theme }) => theme.mediaQueries.md} {
    width: 100%;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    width: 90%;
  }
`;
const StyledBreadCrumbContainer = styled("div")`
  margin: 0 auto;
  max-width: 1440px;
  width: 90%;
`;

const StyledHeading = styled(Heading)`
  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 36px;
    line-height: 45px;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    font-size: 100px;
    line-height: 97px;
  }
`;

const items = [
  { title: "HOME", link: "/" },
  { title: "OUR FACILITY", link: "/facilities" },
];
const Facility = () => {
  const screens = useBreakpoint();
  return (
    <MainLayout bg="/images/facility-bg.webp">
      <StyledWrapper>
        <StyledBreadCrumbContainer>
          <Breadcrumb items={items} current="News" />
        </StyledBreadCrumbContainer>
        <StyledContentContainer>
          <StyledHeading mt={screens.xs ? "40px" : "63px"} fontWeight="900">
            Our Facility
          </StyledHeading>

          <FacilityList />
        </StyledContentContainer>
      </StyledWrapper>
    </MainLayout>
  );
};

export default Facility;
